import { render, staticRenderFns } from "./dialog-exchange-houses.vue?vue&type=template&id=0ede4988&scoped=true&"
import script from "./dialog-exchange-houses.vue?vue&type=script&lang=js&"
export * from "./dialog-exchange-houses.vue?vue&type=script&lang=js&"
import style0 from "./dialog-exchange-houses.vue?vue&type=style&index=0&id=0ede4988&lang=scss&scoped=true&"
import style1 from "./dialog-exchange-houses.vue?vue&type=style&index=1&id=0ede4988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede4988",
  null
  
)

export default component.exports